var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "guests-and-rooms" }, [
    _c(
      "div",
      { ref: "header", staticClass: "guests-and-rooms-header" },
      [
        _vm.isAdultGuest
          ? _c("header-close", { attrs: { back: _vm.getBack } })
          : _vm._e(),
        _vm._v(" "),
        _c("h6", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.tc("booking.guestsAndRooms"))),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    !_vm.isBookingEditMode
      ? _c(
          "div",
          { ref: "notification", staticClass: "guests-and-rooms-notification" },
          [
            _c("span", { staticClass: "label" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.tc("booking.moreThenFiveRooms")) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "cta" }, [
              _c(
                "a",
                {
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.$emit("change-page", "call-to-book")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.tc("booking.call")))]
              ),
            ]),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "guests-and-rooms-body",
        style: [{ height: _vm.scrollHeight + "px" }],
      },
      [
        _c("guests-input", {
          attrs: {
            index: "1",
            "max-guests-allowed": _vm.maxGuestsAllowed,
            "selected-hotel": _vm.selectedHotel,
          },
          on: {
            isDisabled: function ($event) {
              _vm.isDisabled = $event
            },
          },
          model: {
            value: _vm.query,
            callback: function ($$v) {
              _vm.query = $$v
            },
            expression: "query",
          },
        }),
        _vm._v(" "),
        _vm._l(_vm.query.aditionalGuests, function (room, i) {
          return _c("guests-input", {
            key: "room-" + i,
            attrs: {
              "is-aditional": "",
              index: i + 2,
              "max-guests-allowed": _vm.maxGuestsAllowed,
              "selected-hotel": _vm.selectedHotel,
            },
            on: {
              remove: function ($event) {
                return _vm.removeRoom(i)
              },
            },
            model: {
              value: _vm.query.aditionalGuests[i],
              callback: function ($$v) {
                _vm.$set(_vm.query.aditionalGuests, i, $$v)
              },
              expression: "query.aditionalGuests[i]",
            },
          })
        }),
        _vm._v(" "),
        !_vm.isBookingEditMode
          ? _c(
              "button",
              {
                staticClass: "add-room",
                attrs: { disabled: _vm.maxRoomsReached },
                on: { click: _vm.addRoom },
              },
              [
                _c("span", { staticClass: "icon-plus" }),
                _vm._v(" "),
                _c("span", { staticClass: "label" }, [
                  _vm._v(_vm._s(_vm.tc("booking.addRoom"))),
                ]),
              ]
            )
          : _vm._e(),
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { ref: "footer", staticClass: "guests-and-rooms-footer" }, [
      _c("div", { staticClass: "confirmation-cta" }, [
        _c(
          "button",
          {
            class: [{ loading: _vm.isLoading }],
            attrs: { disabled: _vm.isDisabled },
            on: { click: _vm.submit },
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.tc("booking.updateGuestsAndRooms")) +
                "\n        "
            ),
            _c("div", { staticClass: "sr-only", attrs: { role: "status" } }, [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.isLoading
                      ? _vm.tc("accessibility.loadingButtonStatus")
                      : ""
                  ) +
                  "\n        "
              ),
            ]),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }